import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [workspace, setWorkspace] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("nusa_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me").then((r) => {
      setUser(r.data.user);
      setWorkspace(r.data.workspace);
    }).catch(() => localStorage.removeItem("nusa_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("nusa_token", r.data.access_token);
    setUser(r.data.user);
    setWorkspace(r.data.workspace);
    return r.data;
  };

  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    localStorage.setItem("nusa_token", r.data.access_token);
    setUser(r.data.user);
    setWorkspace(r.data.workspace);
    return r.data;
  };

  const logout = () => {
    localStorage.removeItem("nusa_token");
    setUser(null);
    setWorkspace(null);
    window.location.href = "/";
  };

  const refreshWorkspace = async () => {
    const r = await api.get("/auth/me");
    setWorkspace(r.data.workspace);
  };

  return (
    <AuthCtx.Provider value={{ user, workspace, loading, login, register, logout, refreshWorkspace }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
